/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export const invoiceStatus = [
  {
    name: '待上传',
    key: 0
  },
  {
    name: '审批中',
    key: 1
  },
  {
    name: '已驳回',
    key: 2
  },
  {
    name: '已通过',
    key: 3
  }
];
export const kfqy = ({ tip, ajax, prop, query, ajaxQuery, key }) => {
  return {
    id: 'kfqy',
    key,
    tip: tip || '请输入客户企业',
    required: false,
    slot: 'ajaxSelect',
    clearable: true,
    ajax,
    prop,
    query,
    ajaxQuery,
    width: 180
  };
};
export default [
  {
    width: 180,
    id: 'status',
    key: 'auditStatus',
    slot: 'select',
    tip: '状态',
    clearable: true,
    required: false,
    options: invoiceStatus,
    defaultValue: 0
  },
  {
    width: 150,
    id: 'monthrange',
    tip: '请选择完税月份',
    text: ['完税月份起', '完税月份止'],
    key: ['proofMonthStart', 'proofMonthEnd'],
    clearable: true,
    required: false,
    slot: 'monthrange',
    format: 'yyyy-MM',
    rangeValue: []
  }
];
